<template>
    <div class="overlay" :class="{ active: isActive}">
        <div class="modal">
            <h2>Your Location</h2>
            <p>You are currently viewing the <span v-text="siteCountry.label"></span> version of the site but it looks like you are in the <span v-text="currentCountry.countryName"></span>. Please choose from the options below.</p>
            <div class="actions">
                <a v-for="site in sites" class="button" :href="site.url" @click="closeForSession">
                    <div class="country-image" :style="countryImage(site.countryCode.value)"></div>
                    <span v-text="'Switch to '+site.countryCode.label"></span>
                </a>
                <a class="button primary-button" @click.prevent="closeForSession">
                    <div class="country-image" :style="countryImage(siteCountry.code.value)"></div>
                    <span>Stay on Site</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    const axios = require('axios').default;

    export default {
        data() {
            return {
                isActive: false,
                currentCountry: () => {}
            }
        },
        props: {
            siteCountry: {
                type: Object,
                required: true
            },
            redirectCountry: {
                type: String,
                default: "*",
            },
            sites: {
                type: Array,
                default: () => [],
            }
        },
        methods: {
            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                if (exdays) {
                    var expires = "expires=" + d.toUTCString();
                }
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie(name) {
                let dc = document.cookie;
                let prefix = name + "=";
                let begin = dc.indexOf("; " + prefix);
                if (begin === -1) {
                    begin = dc.indexOf(prefix);
                    if (begin !== 0) return null;
                } else {
                    begin += 2;
                    var end = document.cookie.indexOf(";", begin);
                    if (end === -1) {
                        end = dc.length;
                    }
                }
                return decodeURI(dc.substring(begin + prefix.length, end));
            },
            countryImage(code) {
                return "background-image:url('/img/countries/svg/" + code.toLowerCase() + ".svg')"
            },
            redirect(url) {
                console.log(url)
                if (url) {
                    window.location = url;
                }
            },
            closeForSession(url) {
                this.isActive = false;
                this.setCookie('GeoRedirectShown', 'true', false)
            },
            getUserLocation() {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        // console.log(position.coords.latitude);
                        // console.log(position.coords.longitude);
                        this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
                    },
                    error => {
                        console.log(error.message);
                    },
                )
            },
            async getStreetAddressFrom(lat, lng) {
                try {
                    var {
                        data
                    } = await axios.get(
                        "https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=" + lat + "&longitude=" + lng + "&localityLanguage=en"
                    );
                    if (data.error_message) {
                        console.log(data.error_message)
                    } else {
                        // we have a country!
                        this.currentCountry = data;
                        if ((this.redirectCountry === '*' || this.redirectCountry === this.currentCountry.countryCode)
                            && (this.currentCountry.countryCode !== this.siteCountry.code)) {
                            this.isActive = true;
                        }


                    }
                } catch (error) {
                    console.log(error.message);
                }
            }
        },
        mounted() {
            if (!this.getCookie('GeoRedirectShown')) {
                this.getUserLocation();
            }
        }
    }
</script>
<style lang="scss" scoped>

    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;

        background-color: rgba(#222, 0.5);
        display: none;

        &.active {
            display: flex;
        }

        flex-wrap: wrap;
        justify-content: center;
        align-content: center;

        .modal {

            width:100%;

            /* Medium and up */
            @media screen and (min-width: 640px) {
                max-width:600px;
            }

            /* Large and up */
            @media screen and (min-width: 1024px) {
                max-width: 700px;
            }

            background-color: #fff;

            padding: 20px;

            h2 {
                font-size: 14px;
                color: var(--tertiary-color);
            }

            p {
                font-size: 14px;
                color: #8A8A8A;
                margin-bottom: 2rem;
            }

            .actions {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                a {
                    display: flex;
                }

                /* Medium and up */
                @media screen and (min-width: 640px) {
                    flex-direction: row;
                    a {

                    }
                }
            }
        }
    }

    .button {
        display: flex;
        background-color: var(--primary-color);
        &:hover {
            background-color: var(--secondary-color);
        }

        &.primary-button {
            background-color: var(--tertiary-color-light-5);
            color: white;

            &:hover {
                border-color: var(--tertiary-color);
                background-color: var(--tertiary-color);
            }
        }

        .country-image {
            width: 24px;
            height: 24px;
            margin: 13px 5px 13px 0;
            background-size: cover;
            background-position: center;
            border-radius: 9999px;
        }
    }
</style>